export default "__VITE_ASSET__DJkcTfGD__"